import type { GoalStructureProvider } from "@/goals/utils/GoalStructureProvider";
import type { GoalSourceContent } from "@/utils/GoalSource";
import type { Curriculum } from "@/models/Curriculum.model";
import { OpStapLoader } from "@/goals/opstap/utils/OpStapLoader.util";

/** Builds the Op Stap display skeleton dynamically from the live KRC document. */
export class OpStapGoalStructureProvider implements GoalStructureProvider {

	async loadContent(curriculum: Curriculum): Promise<GoalSourceContent | null> {
		try {
			const content = await new OpStapLoader().loadStructure();
			content.name = curriculum.name;
			return content;
		} catch (e) {
			console.error('Could not build the Op Stap goal structure', e);
			return null;
		}
	}

}
